import React, { useEffect } from "react";

const Adsone = () => {
  useEffect(() => {
    try {
      // Load the Google Ads script only once
      const script = document.createElement("script");
      script.src = "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-1874554549734336";
      script.async = true;
      script.crossOrigin = "anonymous";
      document.head.appendChild(script);

      // Wait a bit and then try to render the ad
      setTimeout(() => {
        if (window.adsbygoogle && Array.isArray(window.adsbygoogle)) {
          window.adsbygoogle.push({});
        }
      }, 500);
    } catch (e) {
      console.error("Adsense error", e);
    }
  }, []);

  return (
    <>
      {/* Ad container */}
      <div style={{ margin: "20px 0", textAlign: "center" }}>
        <ins
          className="adsbygoogle"
          style={{ display: "block" }}
          data-ad-client="ca-pub-1874554549734336"
          data-ad-slot="2058353944"
          data-ad-format="auto"
          data-full-width-responsive="true"
        ></ins>
      </div>
    </>
  );
};

export default Adsone;
